/* src/app/components/automatic-promo-modal/automatic-promo-modal.component.css */
:host {
  display: block;
  position: relative;
  height: 100%;
  width: 100%;
}
.promo-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.automatic-promo-modal-root {
  position: relative;
  z-index: 1;
  height: 100%;
  padding: 24px;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.automatic-promo-modal-root::before {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.35),
      rgba(0, 0, 0, 0.65));
  z-index: 0;
  pointer-events: none;
}
.promo-title,
.promo-description,
.confirm-button,
.decline-button {
  position: relative;
  z-index: 2;
}
.promo-title {
  font-size: 2em;
  font-weight: bold;
  margin: 20px 0;
  color: white;
}
.promo-description {
  margin: 20px 0;
  white-space: pre-line;
}
.confirm-button {
  color: black;
  --background: cyan;
}
.decline-button {
  color: cyan;
  --background: black;
}
/*# sourceMappingURL=automatic-promo-modal.component.css.map */
